/**
 * Helpers for resolving organization display names in notifications.
 */

/**
 * @param {unknown[]} lists
 * @returns {object[]}
 */
export function mergeOrganizationLists(...lists) {
  const byId = new Map();
  lists.forEach((list) => {
    (Array.isArray(list) ? list : []).forEach((org) => {
      const id = org?.id ?? org?.organization_id;
      if (id == null || id === '') return;
      byId.set(String(id), org);
    });
  });
  return [...byId.values()];
}

/**
 * @param {string|number|null|undefined} entityId
 * @param {object[]} [organizations]
 * @returns {{ id: string|number, name: string }|null}
 */
export function findOrganizationInLists(entityId, organizations = []) {
  if (entityId == null || entityId === '') return null;
  const idStr = String(entityId);
  const found = (Array.isArray(organizations) ? organizations : []).find((org) => {
    const oid = org?.id ?? org?.organization_id;
    return oid != null && String(oid) === idStr;
  });
  if (!found) return null;
  const name = (found.name ?? found.naziv ?? found.organization_name ?? '').trim();
  if (!name) return null;
  return {
    id: found.id ?? found.organization_id,
    name,
  };
}

/**
 * @param {string|number|null|undefined} entityId
 * @param {Record<string, string>} [organizationNameById]
 * @returns {string|null}
 */
export function organizationNameFromCache(entityId, organizationNameById = {}) {
  if (entityId == null || entityId === '') return null;
  const name = organizationNameById[String(entityId)];
  return typeof name === 'string' && name.trim() ? name.trim() : null;
}
